module.exports = __webpack_public_path__ + "img/wordmark.a6655f2e.svg";